import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE_URL = "https://admin.shopaholics.ge/api";

const useSession = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // ✅ Prevent unnecessary redirects
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/session_check.php`, { 
          withCredentials: true, // ✅ Ensures cookies are sent
        });

        console.log("🔍 API Response from session_check:", res.data);

        if (res.data.user) {
          setUser(res.data.user);
          localStorage.setItem("user", JSON.stringify(res.data.user));
        } else {
          console.warn("❌ Session expired, logging out...");
          setUser(null);
          localStorage.removeItem("user");
          navigate("/login", { replace: true });
        }
      } catch (error) {
        console.error("❌ Session check failed:", error);

        // ✅ Ensure we don't log out due to temporary server issues
        if (!navigator.onLine) {
          console.warn("⚠️ No internet connection. Skipping logout.");
          return;
        }

        setUser(null);
        localStorage.removeItem("user");
        navigate("/login", { replace: true });
      } finally {
        setLoading(false); // ✅ Stop loading after session check
      }
    };

    checkSession(); // ✅ Run once on mount

    const interval = setInterval(checkSession, 10000); // ✅ Run every 10 seconds

    return () => clearInterval(interval); // ✅ Cleanup on unmount
  }, [navigate]);

  return { user, setUser, loading }; // ✅ Return loading state
};

export default useSession;
